import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import moment from 'moment';
import Dropdown from 'components/Dropdown';
import { isFullSiteMode } from 'utils/fullSite';
import Toggle from './Toggle';
import MonthSelectBox from './MonthSelectBox';
import RangeBox from './RangeBox';
import DateBox from './DateBox';
import ApplyBox from './ApplyBox';
import styles from './DropdownCalendarPromo.css';

class DropdownCalendarPromo extends React.Component {
  constructor(props) {
    super(props);
    const {
      input: { value },
    } = this.props;
    this.state = {
      open: false,
      startDate:
        value && value.startDate
          ? value.startDate
          : moment()
              .add(1, 'days')
              .startOf('day')
              .toISOString(),
      endDate:
        value && value.endDate
          ? value.endDate
          : moment()
              .add(2, 'days')
              .endOf('day')
              .toISOString(),
      month:
        value && value.startDate
          ? moment(value.startDate).month()
          : moment().month(),
      year:
        value && value.startDate
          ? moment(value.startDate).year()
          : moment().year(),
    };
  }

  componentWillReceiveProps(nextProps) {
    const { input } = nextProps;
    if (input) {
      const { value } = input;
      let { startDate, endDate } = this.state;
      if (!startDate || !moment(value.startDate).isSame(startDate)) {
        startDate = value.startDate;
        this.setState({
          month: moment(startDate).month(),
          year: moment().year(),
        });
      }
      if (!endDate || !moment(value.endDate).isSame(endDate)) {
        endDate = value.endDate;
      }
      this.setState({
        startDate,
        endDate,
      });
    }
  }

  componentDidMount() {
    // Don't remove this code, this code for https://mokapos.atlassian.net/browse/FD-38#comment-34124 (first comment)
    $(
      'div#dropdown-box-calendar ul.dropdown-menu li a[role="menuitem"]'
    ).removeAttr('href');
  }

  render() {
    return (
      <div className={styles.wrapper} id="dropdown-box-calendar">
        <Dropdown
          id="dropdown-group"
          open={this.state.open}
          onToggle={this._onToggleDropdown}
          className={styles.dropdown}
        >
          <div
            className={
              !isFullSiteMode()
                ? 'btn-group'
                : `btn-group ${styles['btn-full-site']}`
            }
          >
            <a
              className={`btn btn-default ${styles['btn-prev-day']}`}
              onClick={this._onClickPrevButton}
              disabled={this._disabledPrevButton()}
            >
              <i className="fa fa-angle-left" />
            </a>
            <Toggle
              bsRole="toggle"
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onClick={this._onClickToggle}
              fullSiteMode={isFullSiteMode()}
            />
            <a
              className={`btn btn-default ${styles['btn-next-day']}`}
              onClick={this._onClickNextButton}
              type="button"
            >
              <i className="fa fa-angle-right" />
            </a>
          </div>
          <Dropdown.Menu
            bsRole="menu"
            className={
              isFullSiteMode()
                ? styles['menu-full-site']
                : styles['dropdown-calendar-promo']
            }
          >
            <MenuItem
              bsClass="menu-item dropdown"
              onClick={() => {
                this._forceOpen = true;
              }}
            >
              <div className="row">
                <div className="col-sm-12">
                  <div
                    className={`col-sm-8 element-non-mobi ${styles.noPadding}`}
                  >
                    <ApplyBox
                      onApply={this._onClickApply}
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      fullSiteMode={isFullSiteMode()}
                    />
                    <MonthSelectBox
                      month={this.state.month}
                      year={this.state.year}
                      onChange={this._onChangeMonthSelectBox}
                      fullSiteMode={isFullSiteMode()}
                    />
                    <DateBox
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      month={this.state.month}
                      year={this.state.year}
                      onChange={this._onChangeDateBox}
                    />
                  </div>
                  <div className="col-sm-4 element-non-mobi">
                    <RangeBox onChange={this._onClickRangeBox} />
                  </div>
                </div>
                {!isFullSiteMode() ? (
                  <div className="col-sm-12 element-mobi">
                    <RangeBox onChange={this._onClickRangeBox} />
                  </div>
                ) : (
                  <div className="col-sm-12 element-mobi">
                    <div
                      className={`col-sm-8 element-mobi ${styles.noPadding}`}
                    >
                      <ApplyBox
                        onApply={this._onClickApply}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        fullSiteMode={isFullSiteMode()}
                      />
                      <MonthSelectBox
                        month={this.state.month}
                        year={this.state.year}
                        onChange={this._onChangeMonthSelectBox}
                        fullSiteMode={isFullSiteMode()}
                      />
                      <DateBox
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        month={this.state.month}
                        year={this.state.year}
                        onChange={this._onChangeDateBox}
                      />
                    </div>
                    <div className="col-sm-4 element-mobi">
                      <RangeBox onChange={this._onClickRangeBox} />
                    </div>
                  </div>
                )}
              </div>
            </MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  _onClickToggle = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  _onToggleDropdown = newValue => {
    if (this._forceOpen) {
      this.setState({ open: true });
      this._forceOpen = false;
    } else {
      this.setState({ open: newValue });
    }
  };

  _onClickPrevButton = () => {
    if (this._disabledPrevButton()) {
      return false;
    }
    const diff = Math.abs(
      moment(this.state.startDate).diff(moment(this.state.endDate), 'days')
    );
    let newStartDate;
    let newEndDate;
    if (diff === 0) {
      newStartDate = moment(this.state.startDate)
        .add(-1, 'days')
        .startOf('day')
        .toISOString();
      newEndDate = moment(this.state.endDate)
        .add(-1, 'days')
        .endOf('day')
        .toISOString();
    } else {
      newEndDate = moment(this.state.startDate)
        .endOf('day')
        .toISOString();
      newStartDate = moment(this.state.startDate)
        .add(-diff, 'days')
        .startOf('day')
        .toISOString();
    }
    if (moment(newStartDate).isBefore(moment().startOf('day'))) {
      newStartDate = moment()
        .add(1, 'days')
        .startOf('day')
        .toISOString();
      newEndDate = moment()
        .add(2, 'days')
        .endOf('day')
        .toISOString();
    }
    this._reduxFormOnChange({ startDate: newStartDate, endDate: newEndDate });
  };

  _onClickNextButton = () => {
    const diff = Math.abs(
      moment(this.state.startDate).diff(moment(this.state.endDate), 'days')
    );
    let newStartDate;
    let newEndDate;
    if (diff === 0) {
      newStartDate = moment(this.state.startDate)
        .add(1, 'days')
        .startOf('day')
        .toISOString();
      newEndDate = moment(this.state.endDate)
        .add(1, 'days')
        .endOf('day')
        .toISOString();
    } else {
      newStartDate = moment(this.state.endDate)
        .startOf('day')
        .toISOString();
      newEndDate = moment(this.state.endDate)
        .add(diff, 'days')
        .endOf('day')
        .toISOString();
    }
    this._reduxFormOnChange({ startDate: newStartDate, endDate: newEndDate });
  };

  _onClickApply = ({ startDate, endDate }) => {
    this.setState({ open: false });
    this._forceOpen = false;
    this._reduxFormOnChange({ startDate, endDate });
  };

  _onClickRangeBox = ({ startDate, endDate }) => {
    this.setState({ open: false });
    this._forceOpen = false;
    this._reduxFormOnChange({ startDate, endDate });
  };

  _onChangeDateBox = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  _onChangeMonthSelectBox = ({ year, month }) => {
    this.setState({ year, month });
  };

  /**
   * Wrapper for redux form on change
   * place before and after action in this method
   * @private
   */
  _reduxFormOnChange = ({ startDate, endDate }) => {
    const {
      input: { onChange },
      onDirtyFormCallback,
      isDirtyForm,
    } = this.props;
    if (isDirtyForm) {
      onDirtyFormCallback({ startDate, endDate });
    } else {
      onChange({ startDate, endDate });
    }
  };

  _disabledPrevButton = () => {
    return !moment(this.state.startDate).isAfter(
      moment().startOf('days'),
      'days'
    );
  };
}

DropdownCalendarPromo.propTypes = {
  input: PropTypes.object,
  updateServerOnChange: PropTypes.bool,
};

export default DropdownCalendarPromo;
